/**
 * Created by Joey Hardy on 2/4/2015.
 */
spanplusApp.value("SearchFilters", function() {
    this.fromDate = '';
    this.toDate = '';
    this.firstName = '';
    this.lastName = '';
    this.businessName = '';   // not all providers use this
    this.vin = '';
    this.contractNumber = '';
    this.loginID = '';
});
